import { gql } from '@apollo/client';

export const GET_INVOICE_TEMPLATES_DOCTOR = gql`
  query GetInvoiceTemplatesDoctor {
    getInvoiceTemplatesDoctor {
      data {
        id
        name
        keys {
          id
          label
          type
          required
        }
      }
    }
  }
`;
